import ShipmentDetails from './shipmentDetails';

export default ShipmentDetails;
